const FloatingSidebar = ({ isOpen, children }: { isOpen: boolean; children: React.ReactNode }) => {
  return (
    <>
      <div
        className={`absolute top-2 right-1 w-1/5 overflow-hidden rounded-2xl bg-white px-1 shadow-sm transition-all duration-300 ease-in-out dark:bg-slate-900 ${isOpen ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'} `}
      >
        {children}
      </div>
    </>
  );
};

export default FloatingSidebar;
